var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToiletsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    id: "svg126",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs24"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style100"
  }, "\r\n        .st0{fill:#010202;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(-28.598211,-17.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 58.9,28.5 c 1.7,0 3,-1.3 3,-3 0,-1.7 -1.3,-3 -3,-3 -1.7,0 -3,1.3 -3,3 0,1.6 1.3,3 3,3 z",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 67,39.2 -4.3,-9.4 c -0.2,-0.5 -0.8,-0.7 -1.3,-0.7 -1.9,0 -2.9,0 -5,0 -0.5,0 -1.1,0.2 -1.3,0.7 l -4.3,9.4 c -0.3,0.6 0,1.4 0.6,1.7 0.3,0.1 0.4,0.1 0.6,0.1 0.5,0 1,-0.3 1.2,-0.8 l 2.1,-4.5 v 4.9 c 0,0 0,0 0,0 v 11.1 c 0,0.9 0.7,1.5 1.5,1.5 0.9,0 1.5,-0.7 1.5,-1.5 v -9.2 h 1.1 v 9.2 c 0,0.9 0.7,1.5 1.5,1.5 0.9,0 1.5,-0.7 1.5,-1.5 v -11 c 0,0 0,0 0,0 v -4.9 l 2.1,4.5 c 0.2,0.5 0.7,0.8 1.2,0.8 0.2,0 0.4,0 0.5,-0.1 0.8,-0.4 1.1,-1.1 0.8,-1.8 z",
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 38.2,28.5 c 1.7,0 3,-1.3 3,-3 0,-1.7 -1.3,-3 -3,-3 -1.7,0 -3,1.3 -3,3 0,1.6 1.3,3 3,3 z",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 42,29.8 c -0.2,-0.5 -0.7,-0.7 -1.1,-0.7 h -5.3 c -0.5,0 -0.9,0.3 -1.1,0.7 l -4.3,9.4 c -0.3,0.6 0,1.4 0.6,1.7 0.2,0.1 0.4,0.1 0.5,0.1 0.5,0 1,-0.3 1.2,-0.8 l 1.3,-2.9 -1.2,5.5 c 0,0.2 0,0.4 0.1,0.5 0.1,0.1 0.3,0.2 0.5,0.2 h 1.3 v 8.2 c 0,0.9 0.7,1.5 1.5,1.5 0.9,0 1.5,-0.7 1.5,-1.5 v -8.2 h 1.1 v 8.2 c 0,0.9 0.7,1.5 1.5,1.5 0.8,0 1.5,-0.7 1.5,-1.5 v -8.2 h 1.3 c 0.2,0 0.4,-0.1 0.5,-0.2 0.1,-0.1 0.2,-0.3 0.1,-0.5 l -1.2,-5.5 1.3,2.9 c 0.2,0.5 0.7,0.8 1.2,0.8 0.2,0 0.4,0 0.5,-0.1 0.6,-0.3 0.9,-1.1 0.6,-1.7 z",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 48.6,24.7 c -0.6,0 -1,0.5 -1,1 v 24.5 c 0,0.6 0.5,1 1,1 0.6,0 1,-0.5 1,-1 V 25.7 c 0.1,-0.6 -0.4,-1 -1,-1 z",
    id: "path110"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletsIcon);
export default __webpack_public_path__ + "static/media/toilets-icon.b74eeca5.svg";
export { ForwardRef as ReactComponent };